import "./TableSum.scss";

import React from "react";
import { inject, observer } from "mobx-react";
import { RouteNode } from "react-router5";

import Frame from "../Frame/Frame";
import PagerAmount from "../../Components/Pager/PagerAmount";
import Pager from "../../Components/Pager/Pager";
import Popup from "../../Components/Popup/Popup";
import RefreshButton from "../../Components/RefreshButton/RefreshButton";
import { STORE_CONFIG } from "../../Store/ConfigStore";
import { ROUTE_TABLE, ROUTE_MAP } from "../../routes";
import { STORE_TABLESUM, SORT_ASC, SORT_DESC } from "../../Store/TableSumStore";
import { STORE_AUTH } from "../../Store/AuthStore";
import axios from "axios";
import DatePicker, { registerLocale } from "react-datepicker";
import hu from "date-fns/locale/hu";
registerLocale("hu", hu);
import { formatDate, formatDateOnly, formatNumber } from "../../utility";
import { timeout } from "q";
import XLSX from "xlsx";

import Select from "react-select";
import { SelectStyle, DropdownIndicator } from "../App/select_style";

const SORT_ITEM = "ItemName";
const SORT_AMOUNT_KG = "SumQuantity";
const SORT_AMOUNT_PCS = "PalletCount";

function Sorter(props) {
  const asc = ["sorter__dir sorter__dir-asc"];
  const desc = ["sorter__dir sorter__dir-desc"];
  if (props.activeDirection === SORT_ASC) {
    asc.push("sorter__dir--active");
  } else if (props.activeDirection === SORT_DESC) {
    desc.push("sorter__dir--active");
  }
  return (
    <div
      className={"sorter" + (props.activeDirection ? " sorter--active" : "")}
    >
      <div className={asc.join(" ")} title="rendezés növekvő sorrendbe" />
      <div className={desc.join(" ")} title="rendezés csökkenő sorrendbe" />
    </div>
  );
}

const TableSearch = inject((stores) => ({
  store: stores.store.get(STORE_TABLESUM),
}))(
  observer((props) => {
    const { store } = props;
    const cancelClassname =
      "search-cancel-button" + (store.search.length > 0 ? "" : " hidden");
    return (
      <div className="table-search">
        <div className="table-search__label">Keresés</div>
        {/*<div className="table-search__input-container">      
        <input className="form-input form-input--inline" type="text" name="focus" value={store.search} onChange={e => store.setSearch(e.target.value)} />       
    </div>*/}
        <div className="search-wrapper">
          <input
            className="search-input"
            value={store.search}
            onChange={(e) => store.setSearch(e.target.value)}
          />
          <div className={cancelClassname} onClick={(e) => store.setSearch("")}>
            <i className="fas fa-times"></i>
          </div>
        </div>
      </div>
    );
  })
);

@inject((stores) => ({
  store: stores.store.get(STORE_TABLESUM),
  configStore: stores.store.get(STORE_CONFIG),
  authStore: stores.store.get(STORE_AUTH),
  socket: stores.socket,
  router: stores.router,
}))
@observer
class TableSum extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popup: "none",
      popupText: "",
      showTerminated: false,
      from: null,
      to: null,
      subtable: null,
    };

    const { store } = this.props;
    store.setSortField(SORT_ITEM);
    store.setSortDirection(SORT_ASC);

    this.refresh();
  }
  onClickSort = (field) => () => {
    const { store } = this.props;
    if (store.sortField === field) {
      store.flipSortDirection();
    } else {
      store.setSortField(field);
      store.setSortDirection(SORT_ASC);
    }
  };

  handleDownload() {
    const { store, configStore } = this.props;
    const { sortedItems } = store;

    const merges = [];
    let data = [
      [
        "Azonosító",
        "Gép",
        "Fok",
        "Beszállító",
        "Cikk",
        "Hely",
        "Mennyiség",
        "Összmennyiség",
        "Tisztaság",
        "Csíra",
        "Víz",
        "Létrehozva",
      ],
    ];
    if (store.showTerminated)
      data[0] = data[0].concat(["Megszüntetve", "Művelet"]);

    let rowindex = 1;

    sortedItems.forEach((pallet) => {
      let row = [
        pallet.LotNo + (pallet.SealNum ? " (" + pallet.SealNum + ")" : ""),
        pallet.MachineText,
        pallet.CleaningRateText +
          (pallet.CustomCleaningRate
            ? " (" + pallet.CustomCleaningRate + ")"
            : ""),
        (pallet.Supplier ? pallet.Supplier : "") +
          (pallet.CustomSupplier ? " (" + pallet.CustomSupplier + ")" : ""),
        pallet.ItemName +
          (pallet.CustomItem ? " (" + pallet.CustomItem + ")" : ""),
        pallet.BinCode,
        (pallet.BagType === 2
          ? pallet.BagCount + " x " + pallet.Quantity
          : pallet.Quantity) + " kg",
        pallet.BagCount * pallet.Quantity,
        pallet.QualityPurity ? pallet.QualityPurity + " %" : "",
        pallet.QualityGerm ? pallet.QualityGerm + " %" : "",
        pallet.QualityWater ? pallet.QualityWater + " %" : "",
        pallet.Created,
      ];

      if (store.showTerminated)
        row = row.concat([
          pallet.Terminated,
          configStore.palletstatuses[pallet.Status],
        ]);

      data.push(row);
    });
    //console.log(data, merges)

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.aoa_to_sheet(data);
    ws["!merges"] = merges;
    XLSX.utils.book_append_sheet(wb, ws, "Táblázat");

    XLSX.writeFile(wb, "Táblázat_" + formatDateOnly(new Date()) + ".xlsx", {
      bookSST: true,
      compression: true,
    });
  }

  refresh() {
    const { store, socket } = this.props;

    const _this = this;
    socket.emitWithToken("GetPalletsSum", {}, function (err, data) {
      if (err) {
        console.error(err);
        return;
      }
      console.log(data);
      store.setItems(data);
      _this.setState({ newContentAvailable: false });
    });
  }

  getPalletHistory(palletid) {
    const { store, socket } = this.props;

    const _palletid = palletid;

    socket.emitWithToken(
      "GetPalletHistory",
      { PalletId: _palletid },
      function (err, data) {
        if (err) {
          console.error(err);
          return;
        }
        store.setPalletHistory({ PalletId: _palletid, Data: data });
      }
    );
  }

  componentDidMount() {
    const { route, store, socket } = this.props;
    if (route.params.hasOwnProperty("search")) {
      store.setSearch(route.params.search);
    }

    socket.on("InventoryChanged", this.inventoryChanged);
  }

  componentWillUnmount() {
    this.props.socket.off("InventoryChanged", this.inventoryChanged);
  }

  inventoryChanged = (data) => {
    if (data && data.UserId == authStore.user.Id) return;
    this.setState({ newContentAvailable: true });
  };

  showPopup = (text) => {
    this.setState({ popup: "show", popupText: text });
  };

  render() {
    const { store, configStore, authStore, route, router, socket } = this.props;
    const { shownItems, sortDirection, sortField, pager, uploading } = store;
    const { itemCount, lastShownItem, firstShownItem } = pager;
    let { name: routeName, params: routeParams } = route;

    let rows = [];

    shownItems.forEach((item) => {
      const subtable = (
        <tr
          key={"s" + item.ItemId}
          id={"s" + item.ItemId}
          className={
            "subtable" + (this.state.subtable === item.ItemId ? "" : " hidden")
          }
        >
          {this.state.subtable === item.ItemId && (
            <table>
              <tr>
                <th>Fok</th>
                <th>Mennyiség</th>
                <th>Raklapszám</th>
                <th>Raktárak</th>
              </tr>
              {item.CleaningRates.map((cleaningrate) => {
                return (
                  <tr>
                    <td
                      className="table-cell-active"
                      onClick={() =>
                        router.navigate(ROUTE_TABLE, {
                          search:
                            item.ItemName +
                            " " +
                            configStore.cleaningRates[
                              cleaningrate.CleaningRate
                            ].split("-")[1],
                        })
                      }
                    >
                      {cleaningrate.CleaningRateText}
                    </td>
                    <td>{formatNumber(cleaningrate.SumQuantity)} kg</td>
                    <td>{cleaningrate.PalletCount} db</td>
                    <td>
                      {cleaningrate.Locations.map((location) => {
                        if (!configStore.locationsById[location]) return null;
                        const locationName =
                          configStore.locationsById[location].Name;
                        return (
                          <div
                            className="table-cell-active"
                            onClick={() =>
                              router.navigate(ROUTE_TABLE, {
                                search:
                                  item.ItemName +
                                  " " +
                                  configStore.cleaningRates[
                                    cleaningrate.CleaningRate
                                  ].split("-")[1] +
                                  " " +
                                  locationName,
                              })
                            }
                          >
                            {locationName}
                          </div>
                        );
                      })}
                    </td>
                  </tr>
                );
              })}
            </table>
          )}
        </tr>
      );

      rows.push(
        <tr key={item.ItemId}>
          <td
            className="table-cell-active"
            onClick={() =>
              router.navigate(ROUTE_TABLE, { search: item.ItemName })
            }
          >
            {item.ItemName}
          </td>
          <td
            className="table-cell-active"
            onClick={() => {
              this.setState((prevState) => {
                return {
                  subtable:
                    prevState.subtable === item.ItemId ? null : item.ItemId,
                };
              });
            }}
          >
            {" "}
            {item.CleaningRatesText}{" "}
          </td>
          <td>{formatNumber(item.SumQuantity) + " kg"}</td>
          <td>{item.PalletCount + " db"}</td>
          <td>
            {item.Locations.map((location) => {
              if (!configStore.locationsById[location]) return null;
              const locationName = configStore.locationsById[location].Name;
              return (
                <div
                  className="table-cell-active"
                  onClick={() =>
                    router.navigate(ROUTE_TABLE, {
                      search: item.ItemName + " " + locationName,
                    })
                  }
                >
                  {locationName}
                </div>
              );
            })}
          </td>
        </tr>
      );
      rows.push(subtable);
    });

    return (
      <Frame>
        <div className="table basic-content">
          <div className="table__top">
            <div>{itemCount} találat</div>
            <TableSearch />
            <RefreshButton
              onClick={() => {
                this.refresh();
              }}
              newContentAvailable={this.state.newContentAvailable}
            />
          </div>
          <div className="table__content">
            <table>
              <thead>
                <tr>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_ITEM)}
                    >
                      Cikk
                      <Sorter
                        activeDirection={
                          sortField === SORT_ITEM ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div className="table__header-cell">Fokok</div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_AMOUNT_KG)}
                    >
                      Mennyiség
                      <Sorter
                        activeDirection={
                          sortField === SORT_AMOUNT_KG ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div
                      className="table__header-cell"
                      onClick={this.onClickSort(SORT_AMOUNT_PCS)}
                    >
                      Raklapszám
                      <Sorter
                        activeDirection={
                          sortField === SORT_AMOUNT_PCS ? sortDirection : null
                        }
                      />
                    </div>
                  </th>
                  <th>
                    <div className="table__header-cell">Raktárak</div>
                  </th>
                </tr>
              </thead>
              <tbody className="table_body">{rows}</tbody>
            </table>
          </div>
        </div>
        {this.state.popup === "none" ? null : (
          <Popup
            key="popup"
            text={this.state.popupText}
            onClickClose={() => this.setState({ popup: "none" })}
          />
        )}
      </Frame>
    );
  }
}

export { SORT_ASC, SORT_DESC, SORT_AMOUNT_KG, SORT_AMOUNT_PCS, SORT_ITEM };

export default (props) => (
  <RouteNode nodeName={ROUTE_TABLE}>
    {(routeProps) => <TableSum {...routeProps} {...props} />}
  </RouteNode>
);
